export default "__VITE_ASSET__BlFQEVRh__"